export interface ApplicationListItem {
  applicationStatus?: string;
  contractId?: string;
  id: string;
}

const IN_FLIGHT_TRACKER_STATUSES = new Set([
  'SUBMITTED',
  'COR_REVIEW',
  'UNDER_REVIEW',
  'RETURNED',
  'COR_APPROVED',
  'FNMS_REVIEW',
  'FNMS_RETURNED',
  'FNMS_APPROVED',
  'VAS_REVIEW',
  'VAS_RETURNED',
  'VAS_APPROVED',
  'VAS_AWAITING_FINGERPRINTS_OR_EAPP',
  'VAS_AWAITING_LOGICAL_ACCESS',
]);

/**
 * The list endpoint returns newest first. Prefer a currently progressing record,
 * then the newest non-draft record. Explicit applicationId links bypass this
 * fallback, which keeps the page application-scoped for future multi-app UI.
 */
export function selectApplicationForStatus(applications: ApplicationListItem[]): ApplicationListItem | undefined {
  return (
    applications.find((application) => IN_FLIGHT_TRACKER_STATUSES.has(application.applicationStatus ?? '')) ??
    applications.find((application) => application.applicationStatus !== 'DRAFT') ??
    applications[0]
  );
}
